import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

function RedirectHandler() {
  const location = useLocation();
  const history = useHistory();

  let a = window.location.pathname;
  a = a.lastIndexOf("/") + 1 === a.length ? a.substring(0, a.length - 1) : a;
  let basePath = a.substring(0, a.lastIndexOf("/"));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const shouldRedirect = params.get("redirectToApprovedContact");

    if (shouldRedirect === "true") {
      history.replace(basePath + "/approvedContact");
    }

    if (!sessionStorage.getItem("contactUrlOrigin")) {
      sessionStorage.setItem("contactUrlOrigin", window?.location?.origin);
    }
  }, [location, history]);

  return null;
}

export default RedirectHandler;
